import type { OverloadedArguments } from 'src/types/utils';

export default function promisify<T>(
  fn: (...args: OverloadedArguments<T>) => any
) {
  return function promisfiedFn(this: unknown, ...args: OverloadedArguments<T>) {
    return new Promise((resolve) => resolve(fn.call(this, ...args)));
  };
}
